define('home/views/NetworkDiscussionCoverView',[
    'underscore',
    'backbone',

    'home/views/ChannelsModuleView',
    'home/views/common/DiscussionCoverBaseView',

    'home/templates/networkDiscussionCover',
], function (
    _,
    Backbone,

    ChannelsModuleView,
    DiscussionCoverBaseView,

    networkDiscussionCoverTemplate
) {
    'use strict';

    var parent = DiscussionCoverBaseView;
    var parentProto = DiscussionCoverBaseView.prototype;

    var NetworkDiscussionCoverView = parent.extend({
        template: networkDiscussionCoverTemplate,

        templateHelpers: function () {
            var existing = DiscussionCoverBaseView.prototype.templateHelpers.apply(this, arguments);
            var thread = this.model.thread;

            return _.defaults({
                hasFavicon: thread.forum.hasFavicon(),
                forumFriendlyUrl: thread.forum.getFriendlyUrl(),
                description: thread.getPlainDescription(),
            }, existing);
        },

        regions: _.defaults({
            channelRegion: '[data-role=channel-module]',
        }, parentProto.regions),

        onRender: function () {
            parentProto.onRender.call(this);
            this.activateRegion(this.channelRegion, this.createChannelsView);
        },

        createChannelsView: function () {
            var shuffledChannels = new Backbone.Collection();

            this.model.channels.ensureFetched().then(_.bind(function () {
                // Once the channels have been fetched, reset the ChannelsModuleView's collection
                // with a shuffled copy of the channels.
                // (Make a copy instead of mutating the collection, as it may be used elsewhere)
                shuffledChannels.reset(_.shuffle(this.model.channels.items.models));
            }, this));

            return new ChannelsModuleView({
                collection: shuffledChannels,
            });
        },
    });

    return NetworkDiscussionCoverView;
});

